// Wild & Grey tiny perf helper
(function(){
  var idle = window.requestIdleCallback || function(cb){ setTimeout(cb, 120); };
  idle(function(){
    // Init optional widgets here only when present
    if (window.Swiper) { /* TODO: init specific sliders where needed */ }
  });
})();